import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popover, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';

class TableOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  columns = () => {
    return [
      {
        title: '文件编号',
        dataIndex: 'no',
        key: 'no',
        render: (text, record) => {
          return (
            <Link to={`/administrative/material/info/${record.uuid}`}>
              <Popover content={record.no}>
                <p
                  style={{
                    width: '180px',
                    margin: '0',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {record.no}
                </p>
              </Popover>
            </Link>
          );
        },
      },
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
        render: text => {
          return (
            <Popover content={text}>
              <p
                style={{
                  width: '200px',
                  margin: '0',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                {text}
              </p>
            </Popover>
          );
        },
      },
      {
        title: '文件类型',
        dataIndex: 'type',
        key: 'type',
      },
      {
        title: '文件有效期',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) => {
          let endDate = '';
          let beginDate = '';
          endDate = record.endDate ? moment(record.endDate).format('YYYY-MM-DD') : '永久';
          beginDate = record.beginDate ? moment(record.beginDate).format('YYYY-MM-DD') : '';
          return (
            <span>
              {beginDate}至{endDate}
            </span>
          );
        },
      },
      {
        title: '所属公司',
        dataIndex: 'company',
        key: 'company',
      },
      {
        title: '所属资料库',
        dataIndex: 'database',
        key: 'database',
      },
      {
        title: '管理员',
        dataIndex: 'manager',
        key: 'manager',
      },
      {
        title: '总量/库存',
        dataIndex: 'amount',
        key: 'amount',
        render: (text, record) => {
          return (
            <span>
              {record.amount}/{record.number || 0}
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: text => {
          switch (text) {
            case 1:
              return '有效';
            case 2:
              return '失效';
            default:
          }
        },
      },
    ];
  };

  render() {
    const { documentList, pagination, isLoading } = this.props;
    return (
      <div>
        <Table
          loading={isLoading}
          // style={{ height: "200px" }}
          onChange={this.handleChange}
          columns={this.columns()}
          dataSource={documentList}
          pagination={pagination}
          rowKey="uuid"
        />
      </div>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(TableOrg);



// WEBPACK FOOTER //
// ./src/components/administrative/material/LookUp/TableOrg.js